import * as React from 'react';
export var useStickyState = function (defaultValue, key) {
    var _a = React.useState(function () {
        var stickyValue = window.localStorage.getItem(key);
        return stickyValue !== null ? JSON.parse(stickyValue) : defaultValue;
    }), value = _a[0], setValue = _a[1];
    React.useEffect(function () {
        window.localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);
    // tslint:disable-next-line: no-unsafe-any
    return [value, setValue];
};
